import { addClass } from "@assistancekaren/react-components";
import styles from "./CenterContent.module.scss";

const CenterContent = addClass("div", styles.centerContent);

export default CenterContent;
